import React, { useState, useContext, useEffect } from "react";
import { Steps, Popover } from "antd";
import {
  getClientProducts,
  openkit,
  payReservations,
} from "../../library/database";
import { AppContext } from "../../context";
import "./Payment.css";
import { lng } from "../../library/language";
import TitleBanner from "../../components/TitleBanner/TitleBanner";
import { ENTITIES } from "../../entities/entitiesConfig";

const { Step } = Steps;

async function getCheckout() {
  let manifest = await openkit.custom.execute("POST", "get_checkout");

  EasypayCheckoutUI.setup(manifest) // eslint-disable-line
    .then(function (modal) {
      modal.onCancel(function () {
        // This is triggered on popup close, if the checkout is not complete
        alert("The checkout was canceled!");
      });
      modal.onClose(function () {
        // This is triggered on popup close, if the checkout is complete
        alert("The checkout was closed!");
      });
      modal.onComplete(function (data) {
        alert("The checkout was finished");
        console.log(data);
      });
    });
}

function Payment({
  confirmedProducts,
  setIsPaymentVisible,
  updateList,
  setUpdateList,
  setActiveKey,
}) {
  const [currentStep, setCurrentStep] = useState(0);
  const info = useContext(AppContext);
  const language = info.language;

  useEffect(() => {
    let script = document.createElement("script");
    script.src =
      "https://api.test.easypay.pt/assets/checkout/js/sdk/1.2.1/checkout.js";
    document.head.appendChild(script);
    getCheckout();
  }, []);

  const pay = async () => {
    payReservations(confirmedProducts);
    setIsPaymentVisible(false);
    setUpdateList(!updateList);
    setActiveKey("3");
  };

  return (
    <div className="ahp-payment-content">
      {currentStep === 0 && (
        <>
          <TitleBanner
            color="blue"
            title="Reservas confirmadas"
            subtitle="Confirme as reservas que pretende pagar e avance para pagamento."
            bordered={false}
          />
        </>
      )}
      <div className="ahp-steps">
        <Steps current={currentStep} responsive>
          <Step key="1" title="Reservas a pagar"></Step>
          <Step key="2" title="Dados"></Step>
          <Step key="3" title="Pagamento"></Step>
        </Steps>
      </div>
      {currentStep === 0 && (
        <>
          {/* <div className="ahp-payment-table">
            <table>
              <thead>
                <tr>
                  <th>Entidade</th>
                  <th>Produto</th>
                  <th>Preço</th>
                </tr>
              </thead>
              <tbody>
                {confirmedProducts.map((p, index) => (
                  <tr key={index}>
                    <td>{lng(p.store_name, language)}</td>
                    <td>
                      <Popover
                        title={p.gen_name}
                        content={popoverContent(p)}
                        trigger="click"
                      >
                        <a>{p.gen_name} </a>
                        <InfoCircleOutlined
                          style={{ color: "#1890ff", cursor: "pointer" }}
                        />
                      </Popover>
                    </td>
                    <td>{p.total_price} €</td>
                  </tr>
                ))}
                <tr>
                  <td style={{ fontWeight: 600 }}>Total</td>
                  <td></td>
                  <td style={{ fontWeight: 600 }}>
                    {confirmedProducts.reduce(
                      (a, c) => (c ? a + c.total_price : a),
                      0
                    )}
                    €
                  </td>
                </tr>
              </tbody>
            </table>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                id="easypay-checkout"
                onClick={() => setIsPaymentVisible(false)}
              ></div>
            </div>
          </div> */}
        </>
      )}
      {currentStep === 1 && (
        <div
          className="ahp-payment-sim"
          style={{
            width: "100%",
            height: "300px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ fontSize: "24px" }}>Dados do cliente</div>
        </div>
      )}
      {currentStep === 2 && (
        <div
          className="ahp-payment-sim"
          style={{
            width: "100%",
            height: "300px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ fontSize: "24px" }}>Pagamento</div>
        </div>
      )}
      <div className="ahp-buttons-bottom">
        {currentStep === 0 && (
          <button
            type="button"
            className="ahp-button"
            onClick={() => setIsPaymentVisible(false)}
          >
            Cancelar
          </button>
        )}
        {/* {currentStep !== 0 && (
          <button type="button" className="ahp-button" onClick={prev}>
            Anterior
          </button>
        )}
        {currentStep !== 2 && (
          <button type="button" className="ahp-button" onClick={next}>
            Seguinte
          </button>
        )}
        {currentStep === 2 && (
          <button type="button" className="ahp-button" onClick={pay}>
            PAGAR
          </button>
        )} */}
      </div>
    </div>
  );
}

export default Payment;
